import { render, staticRenderFns } from "./NewPayments.vue?vue&type=template&id=9ad0bfb2&scoped=true&"
import script from "./NewPayments.vue?vue&type=script&lang=js&"
export * from "./NewPayments.vue?vue&type=script&lang=js&"
import style0 from "./NewPayments.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NewPayments.vue?vue&type=style&index=1&id=9ad0bfb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad0bfb2",
  null
  
)

export default component.exports